// extracted by mini-css-extract-plugin
export default {"root":"Image_root__8Ya4g"};